import React, { Component,Fragment } from 'react'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getRank } from './ranking.actions'
import { Icon } from 'antd'
import './ranking.css'

class Ranking extends Component {
  constructor(props) {
    super(props)
    this.state = {}
      
  }
  componentDidMount(){
      this.props.getRank()
  }

  render() {
    const { loading ,userLogged} = this.props.auth
    const { loading: loadRank, rank: dataRanking } = this.props.rank
    const rank = (data,branch) => {
       
        data.sort((a,b)=> -a.value+b.value)
        let pos = 1
        const setRank = data.map( (rank,index,arr) => {

            if(index){
                if(rank.value === arr[ index - 1 ].value ){
                    rank.pos = pos
                }
                else{
                    rank.pos = index + 1
                    pos = index + 1
                }
            }
            else{
                rank.pos = pos 
            } 
            return rank
        })
        let myPosInRank = setRank.sort((a,b)=> a.branch === branch ? -1 : b.branch === branch ? 1 : 0)
        return myPosInRank.map(item=>(
            <li key={item.branch} className={item.branch === branch ? "ranking-item item-selected":"ranking-item"}>
                    <em> {item.pos}º </em>
                    <p> {item.branch} </p> 
                    <strong> {item.value} pt </strong>
                </li>
        ))
    }

    return (
        <Fragment>
           {
               loading || loadRank ? 
               <div className="center">
                    <Icon type='sync' spin={true} className="   icon-value-rank "  />
                </div>
                :
               <section className='ranking-main'>
                    <h2 className='ant-card-head-title'> Ranking de uso das unidades </h2>
                    <ul className='ranking-list'>
                    {rank(dataRanking,userLogged.branch)}
                    </ul>
                </section> 
               
        }
        </Fragment>
    )
  }
}
const mapStateToProps = ({ auth,rank }) => ({
    auth: auth,
    rank: rank
})

export default connect(mapStateToProps, {getRank})(Ranking)





// WEBPACK FOOTER //
// ./src/App/containers/ranking/ranking.js